// extracted by mini-css-extract-plugin
export var aSpacerHeader = "ja";
export var animationMarquee = "ka";